export default __webpack_public_path__ + "static/media/Waveform_Generators.1f301656.png";